export const CareersContent = [
    {
        id : 1,
        designation : 'Social Media Influencer Interns',
        post : 'Join and dive into the world of automotive content creation! Help us drive brand engagement and connect with car enthusiasts across social platforms.'
    },
    {
        id : 2,
        designation : 'Video Editing Interns',
        post : 'Join us and bring automotive stories to life! Enhance your editing skills while creating engaging content for car enthusiasts everywhere.'
    },
    {
        id : 3,
        designation : 'Automotive Content Interns',
        post : 'Join The Carzilla.In as an Automotive Content Writer Intern and create engaging stories that captivate car enthusiasts!' 
    }
];